import React from 'react';
import { equals } from 'ramda';
import { ROLES } from '../../lib/rights';
import MenuAdminLayout from '../../components/users/MenuAdminLayout';
import UsersList from '../../components/users/UsersList';

const Users = () => {
  return (
    <MenuAdminLayout
      title="Utilisateurs"
      description="Gérez les utilisateurs et leurs rôles (administrateur, éditeur ou lecteur), par équipe et par offre"
    >
      <UsersList
        type="administration"
        itemDisabled={(role) => equals(role, ROLES.superAdmin)}
      />
    </MenuAdminLayout>
  );
};

export default Users;